'use client'

import React from 'react'
import { useElementVisible } from '@hooks/useElementVisible'
import { LeadershipMock } from '@components/AboutUs/AboutUsMock'
import styles from './Leadership.module.scss'
import { Founder } from './Founder'

const LeadershipSection = () => {
  const headerSection = useElementVisible({ threshold: 1 })
  return (
    <div className={styles.founderContainer}>
      <div
        ref={headerSection.ref}
        className={`${styles.founderContainerHeader} ${headerSection.isVisible ? styles.visible : ''}`}>
        <p className={styles.founderHeader1}>{LeadershipMock?.title}</p>
        <p className={styles.founderHeader2}>{LeadershipMock?.description}</p>
      </div>
      <div className={styles.founderCardsContainer}>
        {LeadershipMock?.founderData?.map((founder, i) => <Founder founder={founder} key={i} />)}
      </div>
    </div>
  )
}

export default LeadershipSection
